export const TOBACCO_USE_DATA = [
    { label: 'Never', value: 'never' },
    { label: 'Last 12 Months', value: 'within_last_12_months' },
    { label: '12 to 23 Months', value: '12_to_23_months' },
    { label: '24 to 35 Months', value: '24_to_35_months' },
    { label: '36 Months or More', value: '36_months_or_greater' },
  ];
